<template>
  <div class="mb-4 flex items-center gap-4">
    <div class="flex w-fit items-center gap-x-1.5">
      <span
        class="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-main-primary"
      >
        <span class="text-sm text-white">{{ totalMetric }}</span>
      </span>
      <h3 class="text-md font-semibold text-primary">
        Total Metrics
      </h3>
    </div>
    <div
      v-if="filterLists.length"
      class="flex max-w-[75%] flex-wrap gap-3"
    >
      <button
        class="text-main-primary"
        @click="$emit('clearAllFilter', true)"
      >
        <RestoreIcon />
      </button>
      <div
        v-for="({ type, name, id }, filterIndex) in filterLists"
        :key="`${filterIndex}-${id}`"
        :class="{
          'flex h-min items-center gap-2 whitespace-nowrap rounded-full bg-[#E9F3F2] px-4 py-1 text-[#218579]':
            (filterIndex < 10 && filtersCollapsed) || !filtersCollapsed,
        }"
      >
        <template
          v-if="(filterIndex < 10 && filtersCollapsed) || !filtersCollapsed"
        >
          <template v-if="type === 'asset'">
            <span>{{ name }}</span>
            <button
              type="button"
              class="text-md"
              @click="$emit('clearAssetFilter', filterLists[filterIndex])"
            >
              <CloseIcon />
            </button>
          </template>
        </template>
      </div>
      <button
        v-if="filterLists.length > 10"
        type="button"
        :title="
          filtersCollapsed ? 'Expand collapsed filters' : 'Show less filters'
        "
        class="flex w-fit items-center bg-green-600 px-3 py-0 text-xs text-white"
        @click="filtersCollapsed = !filtersCollapsed"
      >
        <span>...</span>
        <ChevronDownSmall :class="{ 'rotate-180': !filtersCollapsed }" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EsgDataUploadMetricFilter',

  props: {
    allFilters: {
      type: Array,
      required: true,
    },
    totalMetric: {
      type: Number,
      default: 0,
    },
  },

  emits: ['clearAllFilter', 'clearAssetFilter'],

  data() {
    return {
      filterLists: this.allFilters,
      filtersCollapsed: true,
      showFilter: false,
    }
  },

  watch: {
    allFilters(newData) {
      this.filterLists = newData
    },
  },
}
</script>
